import { useParams } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import { getGuide } from "@/data/content/guides";
import { ContentArticleLayout, GuideSectionBlock } from "@/components/content/ContentArticleLayout";
import { ROUTE_PATHS } from "@/routes/routePaths";

export default function GuideArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const guide = slug ? getGuide(slug) : undefined;

  if (!guide) return <NotFound />;

  return (
    <ContentArticleLayout
      eyebrow={guide.eyebrow}
      title={guide.title}
      description={guide.description}
      intro={guide.intro}
      relatedLinks={guide.relatedLinks}
      cta={{ label: "Find rides on Duri", path: ROUTE_PATHS.FIND_RIDES }}
    >
      {guide.sections.map((section) => (
        <GuideSectionBlock
          key={section.heading}
          heading={section.heading}
          paragraphs={section.paragraphs}
          bullets={section.bullets}
        />
      ))}
    </ContentArticleLayout>
  );
}
